export default {"src":"/_next/static/media/loan_cancellation.465e4cf9.svg","height":154,"width":180,"blurWidth":0,"blurHeight":0};